export default "__VITE_ASSET__fboLHZNO__"